import { create } from 'zustand';

export interface DrawerStore {
  drawerOpen: boolean;
  setDrawerOpen: (isOpen: boolean) => void;

  selectedMenu: string;
  setSelectedMenu: (
    menu: 'PATIENT_DATA' | 'MODELS' | 'DRUG_INTERACTIONS' | 'PERSONAL_SETTINGS' | 'POLICY' | 'HISTORY'| 'OFFICE' | ''
  ) => void;
}

export const useDrawerStore = create<DrawerStore>()((set, get) => ({
  drawerOpen: false,
  setDrawerOpen: (isOpen: boolean) => {
    set((prev) => {
      return {
        ...prev,
        drawerOpen: isOpen,
      };
    });
  },
  selectedMenu: '',
  setSelectedMenu: (menu: string) => {
    set((prev) => {
      return {
        ...prev,
        selectedMenu: menu,
      };
    });
  },
}));
